var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('v-btn',{staticStyle:{"width":"auto"},attrs:{"icon":"","title":_vm.$t('layouts.login.logout')},on:{"click":_vm.submit}},[_c('v-icon',[_vm._v("fa fa-sign-out-alt")]),_c('span',{staticStyle:{"color":"#fff","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$t("layouts.login.logout")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }